import React from "react";
import Textarea from "./Textarea";
import * as styles from "../BulkUpdate.module.scss";

export default class MultilineField extends React.Component {
  handleChangeValue = (value) => {
    const { onChangeValue } = this.props;
    onChangeValue({ value });
  };

  render() {
    const { value, policy, fieldInfo, onChangePolicy } = this.props;
    const inputId = `bulk-update-field-input-${fieldInfo.name}`;
    const selectId = `bulk-update-field-select-${fieldInfo.name}`;

    return (
      <div>
        <div>
          <label
            htmlFor={inputId}
          >{`Type in the text you would like to add to “${fieldInfo.label}”:`}</label>
          <Textarea
            id={inputId}
            className={styles.textarea}
            value={value}
            onUpdate={this.handleChangeValue}
          />
        </div>

        <div className={styles.policy}>
          <label htmlFor={selectId}>
            Please specify how you would like the text to appear:
          </label>
          <select
            id={selectId}
            className={styles.select}
            value={policy}
            onChange={onChangePolicy}
          >
            <option value="below">
              Add new text on a line BELOW existing text
            </option>
            <option value="above">
              Add new text on a line ABOVE existing text
            </option>
            <option value="replace">
              Delete existing text and REPLACE with new text
            </option>
            <option value="emptyOnly">Update only if field is EMPTY</option>
          </select>
        </div>
      </div>
    );
  }
}
